module.exports = __webpack_public_path__ + "static/media/DT_head.f9367932.png";